import React, { useEffect } from 'react';
import PageWayfinding from '../../components/common/PageWayfinding';
import './ToolPage.css';

const ToolPageLayout = ({
  title,
  pageTitle,
  lead,
  headerTag,
  eyebrow = 'Инструмент',
  wide = false,
  showEyebrow = true,
  children,
}) => {
  const resolvedPageTitle = pageTitle ?? (typeof title === 'string' ? title : '');

  useEffect(() => {
    if (!resolvedPageTitle) {
      return;
    }

    document.title = resolvedPageTitle.includes('marketDir')
      ? resolvedPageTitle
      : `marketDir — ${resolvedPageTitle}`;
  }, [resolvedPageTitle]);

  return (
    <main className={`tool-page${wide ? ' tool-page--wide' : ''}`}>
      <PageWayfinding showTools />
      {showEyebrow ? <div className="tool-page-eyebrow">{eyebrow}</div> : null}
      {headerTag ? (
        <header className="tool-page-header">
          <div className="tool-page-header-main">
            <h1>{title}</h1>
            {lead ? <p className="tool-page-lead">{lead}</p> : null}
          </div>
          <div className="tool-page-header-tag">{headerTag}</div>
        </header>
      ) : (
        <>
          <h1>{title}</h1>
          {lead ? <p className="tool-page-lead">{lead}</p> : null}
        </>
      )}
      {children}
    </main>
  );
};

export default ToolPageLayout;
